const HALF_VS_FULL_KEYS = [
  ["homeHandicap", "homeHandicapHalfOdds", "homeHandicapOdds"],
  ["handicapValue", "handicapHalfValue", "handicapValue"],
  ["awayHandicap", "awayHandicapHalfOdds", "awayHandicapOdds"],
  ["homeHandicapTrend", "homeHandicapHalfTrend", "homeHandicapTrend"],
  ["awayHandicapTrend", "awayHandicapHalfTrend", "awayHandicapTrend"],
  ["overOdds", "overHalfOdds", "overOdds"],
  ["overUnderValue", "overUnderHalfValue", "overUnderValue"],
  ["underOdds", "underHalfOdds", "underOdds"],
  ["overTrend", "overHalfTrend", "overTrend"],
  ["underTrend", "underHalfTrend", "underTrend"],
  ["home1x2", "homeEuropeHalfOdds", "homeEuropeOdds"],
  ["draw1x2", "drawHalfOdds", "instantDrawOdds"],
  ["away1x2", "awayEuropeHalfOdds", "awayEuropeOdds"],
  ["home1x2Trend", "homeEuropeHalfTrend", "homeEuropeTrend"],
  ["draw1x2Trend", "drawHalfTrend", "drawTrend"],
  ["away1x2Trend", "awayEuropeHalfTrend", "awayEuropeTrend"],
];

export function getDreamnOddsForPeriod(oddsRaw, isHalfTime) {
  return Object.fromEntries(
    HALF_VS_FULL_KEYS.map(([outKey, halfKey, fullKey]) => [
      outKey,
      oddsRaw[isHalfTime ? halfKey : fullKey],
    ]),
  );
}
